<template>
  <span class="value-show">
    {{value}}
  </span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      let value = eval('this.item.' + this.column.name)
      if(value === undefined){
        return "–"
      }
      if(this.column.relative){
        return moment(value).fromNow()
      }else if(this.column.time) {
        return moment(value).format("DD.MM.YYYY HH:mm:ss")
      }else{
        return moment(value).format("DD.MM.YYYY")
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueDate.vue?ca96f0be